import { render, staticRenderFns } from "./MessagesSystem.vue?vue&type=template&id=472d6729"
import script from "./MessagesSystem.vue?vue&type=script&lang=js"
export * from "./MessagesSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports